import { FC } from 'react';
import { createAction } from '@reduxjs/toolkit';
import uniqueId from 'lodash/uniqueId';
// eslint-disable-next-line no-restricted-imports
import { IconProps } from '../../ui/icon/createIconComponent';
// eslint-disable-next-line no-restricted-imports
import { ButtonColor } from '../../ui/input/Button';
import type { NotificationModel } from './types';
import type { RootState } from '../store';
import type { AnyAction } from 'redux';
import type { ThunkAction } from 'redux-thunk';

export const pushNotification = createAction<NotificationModel>('@@notification/PUSH_NOTIFICATION');

export const popNotification = createAction<NotificationModel>('@@notification/POP_NOTIFICATION');

export function showNotificationAsync(
    message: string,
    timeout: number = 3500,
): ThunkAction<void, RootState, undefined, AnyAction> {
    return async (dispatch) => {
        const notification: NotificationModel = { id: uniqueId('notification_'), message };
        dispatch(pushNotification(notification));

        setTimeout(() => {
            dispatch(popNotification(notification));
        }, timeout);
    };
}

interface showToastAsyncProps {
    message: string;
    subtitle?: string;
    actionText?: string;
    onClick?: VoidFunction;
    timeout?: number;
    icon?: FC<IconProps>;
    color?: ButtonColor;
}

export function showToastAsync({
    message,
    subtitle,
    actionText,
    onClick,
    timeout = 3500,
    icon,
    color,
}: showToastAsyncProps): ThunkAction<void, RootState, undefined, AnyAction> {
    return async (dispatch) => {
        const notification: NotificationModel = {
            id: uniqueId('notification_'),
            message,
            subtitle,
            actionText,
            onClick,
            variant: 'toast',
            icon,
            color,
        };

        dispatch(pushNotification(notification));

        setTimeout(() => {
            dispatch(popNotification(notification));
        }, timeout);
    };
}
